import React, {useCallback, useEffect, useState} from 'react';
import {
  Card, Form, Input
} from 'antd';
import {NestingGrid} from "../../NestingGrid";
import {SearchOutlined} from "@ant-design/icons";
import {debounce, escapeRegExp} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {fetchAcceptedNestingJobs, completeJob} from "../../../../../actions/nestingActions";

export const AcceptedNesting = (props) => {
  const { onViewPlate, onCompleteJob, selectedTab } = props;

  const [searchForm] = Form.useForm();

  const [filteredJobs, setFilteredJobs] = useState(null);
  const [isSearchingJobs, setIsSearchingJobs] = useState(false);

  const isFetchingJobs = useSelector(state => state.nesting.isFetchingAcceptedJobs);
  const acceptedJobs = useSelector(state => state.nesting.acceptedJobs);

  const dispatch = useDispatch();

  useEffect(() => {
    if(selectedTab === "2") {
      setFilteredJobs(acceptedJobs);
      dispatch(fetchAcceptedNestingJobs());
    }
    resetAll()
  }, [selectedTab])

  const resetAll = () => {
    searchForm?.setFieldsValue({
      search: ""
    })
  }

  useEffect(() => {
    setFilteredJobs(acceptedJobs);
  }, [acceptedJobs]);

  const filterJobs = (data) => {
    if(!data.text) {
      setFilteredJobs(data.jobs)
    } else {
      const orders = data.jobs.filter(item => {
        const laserStr = item?.selectedCuttingMachine?.name || "";
        return (`${item.name} ${item.material} ${item.width} ${item.height} ${item.thickness}mm ${laserStr}`)
              .toLowerCase().search(escapeRegExp(data.text.toLowerCase())) !== -1
      })
      setFilteredJobs(orders)
    }
    setIsSearchingJobs(false)
  }

  const debounceSearchJobs = useCallback(
    debounce(data => filterJobs(data), 800),
    []
  );

  const searchJobs = (text) => {
    setIsSearchingJobs(true)
    debounceSearchJobs({jobs: acceptedJobs, text})
  }

  return (
    <React.Fragment>
      <Card className={"tabMaterialCard"} bodyStyle={{paddingRight: 0}}>
        <div style={{height: 'calc(100vh - 120px)', overflowY: "auto", overflowX: "hidden", paddingRight: 15}}>
          <div style={{display: "flex", alignItems: "center", marginBottom: 10}}>
            <div style={{fontSize: 13, fontWeight: 500}}>
              Search accepted jobs:
            </div>
            <div style={{marginLeft: 8, fontSize: 13, fontWeight: 500}}>
              <Form
                form={searchForm}
              >
                <Form.Item
                  name={"search"}
                  style={{marginBottom: 0, height: 28}}
                >
                  <Input
                    autoComplete="off"
                    prefix={<SearchOutlined/>}
                    placeholder={"Type here to search"}
                    style={{height: 28, marginTop: -5}}
                    onChange={(e)=>searchJobs(e.target.value)}
                    disabled={isFetchingJobs}
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
          <div className={"nestingCard"} style={{height: 'calc(100vh - 158px)', overflowX: "hidden"}}>
            <NestingGrid gridItems={filteredJobs}
                         isFetchingItems={isFetchingJobs}
                         isSearching={isSearchingJobs}
                         buttonText={"Complete"}
                         onClick={onCompleteJob}
                         plateState={"accepted"}
                         viewPlate={onViewPlate}
            />
          </div>
        </div>
      </Card>
    </React.Fragment>
  )
}